import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  logoUrl: "",
  logoWidth: 96,
  logoHeight: 96,
  loaded: false
};

const brandingSlice = createSlice({
  name: "branding",
  initialState,
  reducers: {
    setBranding: (state, action) => {
      state.logoUrl = action.payload?.logoUrl || "";
      state.logoWidth = Number(action.payload?.logoWidth) || 96;
      state.logoHeight = Number(action.payload?.logoHeight) || 96;
      state.loaded = true;
    }
  }
});

export const { setBranding } = brandingSlice.actions;

export default brandingSlice.reducer;
